// extracted by mini-css-extract-plugin
export default {"page_wrap":"App_page_wrap__uOwxr"};